module.exports = __webpack_public_path__ + "img/9788996100188.bd2a4560.jpg";